import MonthSheet from "./MonthSheet";
import { useState } from "react";
import { getLastUpdated } from "./belegungsPlan";

export function Calendar() {
    const [rowCount, setRowCount] = useState(4);
    const now = new Date();
    const startYear = now.getFullYear();
    let monthCounter = now.getMonth();

    function increaseRowCount() {
        setRowCount(rowCount => rowCount + 1);
    }

    const monthBlocks = [];
    for (let row = 0; row < rowCount; row++) {
        for (let column = 0; column < 4; column++) {
            const date = new Date(Date.UTC(startYear, monthCounter));
            monthCounter++;
            const currentYear = date.getFullYear();
            const currentMonth = date.getMonth() + 1;
            monthBlocks.push(
                <MonthSheet key={`${currentYear}-${currentMonth}`} year={currentYear}
                            month={currentMonth}>
                </MonthSheet>
            )
        }
    }

    return <div>
        <div className="EmbeddableCalendar">
            <div className="TopBox">
                <div className="LegendBox">
                    <table>
                        <tbody>
                        <tr>
                            <td className="Image Neutral">&nbsp;</td>
                            <td className="Caption">keine Angabe</td>
                            <td className="Image Free">&nbsp;</td>
                            <td className="Caption">frei</td>
                            <td className="Image Reserved">&nbsp;</td>
                            <td className="Caption">reserviert</td>
                            <td className="Image Booked">&nbsp;</td>
                            <td className="Caption">belegt</td>
                            <td className="Image Unavailable">&nbsp;</td>
                            <td className="Caption">nicht verfügbar</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {monthBlocks}
        </div>
        <div style={{clear: 'left'}}>
            <a onClick={(event) => {
                event.preventDefault()
                increaseRowCount();
            }} href='#'>weitere Monate anzeigen ...</a>
        </div>
        <div className="LastChanged">(letzte Aktualisierung am {getLastUpdated()})</div>
    </div>
}
